import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright (c) 2021 lingdocs.com
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { translatePhonetics } from "../lib/translate-phonetics";

var Phonetics = function Phonetics(_ref) {
  var opts = _ref.opts,
      text = _ref.children;

  if (opts.phonetics === "none") {
    return null;
  }

  return _jsx("span", Object.assign({
    className: "f-text"
  }, {
    children: opts.phonetics === "lingdocs" ? text.f : translatePhonetics(text.f, {
      dialect: opts.dialect,
      system: opts.phonetics
    })
  }), void 0);
};

export default Phonetics;